"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const globalStyle_1 = __importDefault(require("../../style/globalStyle"));
exports.default = {
    root: {
        display: 'block',
        fill: globalStyle_1.default.indigo1
    },
    type: {
        '&[data-fill-white=true]': {
            fill: globalStyle_1.default.white1
        }
    }
};
//# sourceMappingURL=logo.triangle.style.js.map